import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead } from "@mui/material";

const PromoPopup = ({ open, onClose, promotions }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle style={{ textAlign: "center", fontWeight: "bold" }}>
        Promociones Válidas
      </DialogTitle>
      <DialogContent>
        <TableContainer component={Paper}>
          <Table>
          <TableHead>
          <TableCell>Título</TableCell>
          <TableCell>Min/Max</TableCell>
          <TableCell>Duración</TableCell>
          <TableCell>Descripción</TableCell>
          </TableHead>
            <TableBody>
              {(promotions || []).map((promo, index) => (
                <TableRow key={index}>
                  <TableCell>{promo.promotion}</TableCell>
                  <TableCell>
                    {(() => {
                      switch (promo.DiscountDetail?.DiscountType || '') {
                        case "PERCENTAGE":
                          return (<>
                              Min:{promo?.Conditions?.ItemValueRange?.MinValue || 0}<br />
                              Max:{promo?.Conditions?.ItemValueRange?.MaxValue || 0}
                            </>);
                        case "NOMINAL":
                          return (<>
                            Min:{promo?.Conditions?.OrderValueRange?.MinValue || 0}<br />
                            Max:{promo?.Conditions?.OrderValueRange?.MaxValue || 0}
                          </>);
                        default:
                          return 0; // Valor predeterminado para casos no manejados
                      }
                    })()}
                  </TableCell>
                  <TableCell>
                    {new Intl.DateTimeFormat("es-PE", {
                       timeZone: "UTC",
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    }).format(new Date(promo.dateStart))} <br/>
                    {new Intl.DateTimeFormat("es-PE", {
                       timeZone: "UTC",
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    }).format(new Date(promo.dateEnd))}
                  </TableCell>
                  <TableCell>{promo.code} <br/> {promo.Description}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PromoPopup;
